import React, { ReactElement } from "react"
import Modal from "react-bootstrap/Modal"
import { map, get } from "lodash"
import { InfoTable } from "components/molecules/table"
import { infoTableColumns } from "config/table_columns"
import { APIResponse } from "redux/apis/types"

type regulationModal = {
  show: boolean
  onHide: Function
  regulationData: Array<APIResponse.Res>
}

export const SymbolRegulationModal = (props: regulationModal) => {
  const { show, onHide, regulationData } = props
  return (
    <Modal
      show={show}
      onHide={() => onHide()}
      size="lg"
      className="symbol-regulation-modal"
      backdrop={true}
    >
      <Modal.Header className="symbol-regulation-header">
        <div className="header-icon ripple" onClick={() => onHide()}>
          <i className="material-icons">close</i>
        </div>
      </Modal.Header>
      <Modal.Body className="symbol-regulation-body">
        <div className="title-border">
          {get(regulationData, "[0].DisplayMessage")}
        </div>
        <div className="symbol-regulation-body-contents">
          <RegulationTable regulationData={get(regulationData, "[0]")} />
          <InfoTable
            list={infoTableColumns.regulationOther}
            data={get(regulationData, "[0]")}
            className="table-striped "
            wrapperCls="symbol-regulation-table-row"
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="symbol-regulation-footer">
        <div className="modal-bottom-btn-row">
          <div className="btn btn-outline ripple" onClick={() => onHide()}>
            閉じる
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

type regulationTable = { regulationData: APIResponse.Res }
type contents = { id: number; contents: ReactElement }

const regulationTableHeaderContents = [
  { id: 0, contents: <th className="vertical-title-cell" /> },
  { id: 1, contents: <th className="vertical-value-cell">買</th> },
  { id: 2, contents: <th className="vertical-value-cell">売</th> },
  { id: 3, contents: <th className="vertical-value-cell">新規買</th> },
  { id: 4, contents: <th className="vertical-value-cell">新規売</th> },
  { id: 5, contents: <th className="vertical-value-cell">返済買</th> },
  { id: 6, contents: <th className="vertical-value-cell">返済売</th> },
  { id: 7, contents: <th className="vertical-value-cell">受株</th> },
  { id: 8, contents: <th className="vertical-value-cell">現渡</th> },
]

const stocksContents = (props: regulationTable) => [
  { id: 0, contents: <td className="vertical-title-cell">現物</td> },
  {
    id: 1,
    contents: (
      <td className="vertical-value-cell">
        {get(props, "StockBuy") === 1 ? "規制" : "-"}
      </td>
    ),
  },
  {
    id: 2,
    contents: (
      <td className="vertical-value-cell">
        {get(props, "StockSell") === 1 ? "規制" : "-"}
      </td>
    ),
  },
  { id: 3, contents: <td className="vertical-value-cell">-</td> },
  { id: 4, contents: <td className="vertical-value-cell">-</td> },
  { id: 5, contents: <td className="vertical-value-cell">-</td> },
  { id: 6, contents: <td className="vertical-value-cell">-</td> },
  { id: 7, contents: <td className="vertical-value-cell">-</td> },
  { id: 8, contents: <td className="vertical-value-cell">-</td> },
]

const stockOptionContents = (props: regulationTable) => [
  { id: 0, contents: <td className="vertical-title-cell">制度</td> },
  {
    id: 1,
    contents: <td className="vertical-value-cell">-</td>,
  },
  {
    id: 2,
    contents: <td className="vertical-value-cell">-</td>,
  },
  {
    id: 3,
    contents: (
      <td className="vertical-value-cell">
        {get(props, "MarginOpenBuy") === 1 ? "規制" : "-"}
      </td>
    ),
  },
  {
    id: 4,
    contents: (
      <td className="vertical-value-cell">
        {get(props, "MarginOpenSell") === 1 ? "規制" : "-"}
      </td>
    ),
  },
  {
    id: 5,
    contents: (
      <td className="vertical-value-cell">
        {get(props, "MarginCloseBuy") === 1 ? "規制" : "-"}
      </td>
    ),
  },
  {
    id: 6,
    contents: (
      <td className="vertical-value-cell">
        {get(props, "MarginCloseSell") === 1 ? "規制" : "-"}
      </td>
    ),
  },
  {
    id: 7,
    contents: (
      <td className="vertical-value-cell">
        {get(props, "ActualRecept") === 1 ? "規制" : "-"}
      </td>
    ),
  },
  {
    id: 8,
    contents: (
      <td className="vertical-value-cell">
        {get(props, "ActualDelivery") === 1 ? "規制" : "-"}
      </td>
    ),
  },
]

const generalContents = (props: regulationTable) => [
  { id: 0, contents: <td className="vertical-title-cell">一般</td> },
  {
    id: 1,
    contents: <td className="vertical-value-cell">-</td>,
  },
  {
    id: 2,
    contents: <td className="vertical-value-cell">-</td>,
  },
  {
    id: 3,
    contents: (
      <td className="vertical-value-cell">
        {get(props, "CompanyMarginOpenBuy1") === 1 ? "規制" : "-"}
      </td>
    ),
  },
  {
    id: 4,
    contents: (
      <td className="vertical-value-cell">
        {get(props, "CompanyMarginOpenSell1") === 1 ? "規制" : "-"}
      </td>
    ),
  },
  {
    id: 5,
    contents: (
      <td className="vertical-value-cell">
        {get(props, "CompanyMarginCloseBuy1") === 1 ? "規制" : "-"}
      </td>
    ),
  },
  {
    id: 6,
    contents: (
      <td className="vertical-value-cell">
        {get(props, "CompanyMarginCloseSell1") === 1 ? "規制" : "-"}
      </td>
    ),
  },
  {
    id: 7,
    contents: (
      <td className="vertical-value-cell">
        {get(props, "CompanyActualRecept1") === 1 ? "規制" : "-"}
      </td>
    ),
  },
  {
    id: 8,
    contents: (
      <td className="vertical-value-cell">
        {get(props, "CompanyActualDelivery1") === 1 ? "規制" : "-"}
      </td>
    ),
  },
]

const regulationContents = [
  stocksContents,
  stockOptionContents,
  generalContents,
]

const RegulationTable = (props: regulationTable) => {
  return (
    <table className="table table-symbol-regulation">
      <thead>
        <tr>
          {map(regulationTableHeaderContents, (data: contents) => {
            return data.contents
          })}
        </tr>
      </thead>
      <tbody>
        {map(regulationContents, (list: Function) => {
          return (
            <tr>
              {map(list(props.regulationData), (data: contents) => {
                return data.contents
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
